import { PixelPlaceholderLoader } from "@similarweb/ui-components";

export const SearchVolumeOverTimeLoaderSkeleton = () => (
    <PixelPlaceholderLoader
        width={160}
        height={250}
    />
);
